import ShortProgrammes from '../components/sections/ShortProgrammes';
import Faqs from '../components/sections/Faqs';

export default function ShortProgrammesPage() {
  return (
    <>
      <section className="bg-hero-glow">
        <div className="container py-14 lg:py-20">
          <div className="max-w-3xl">
            <span className="eyebrow">Four months</span>
            <h1 className="mt-5 text-4xl leading-tight sm:text-5xl">
              Short programmes and vendor certifications
            </h1>
            <p className="mt-6 text-lg leading-relaxed text-brand-900/65">
              Focused Microsoft and CompTIA tracks for learners who want a
              specific certification rather than a full national qualification.
            </p>
          </div>
        </div>
      </section>

      <ShortProgrammes />
      <Faqs />
    </>
  );
}
